export default "assets/images/footer-bg-dc3acb47.png";